// Field order for onboarding form: name → email → phone (then any others)
// Lower number = earlier in the form. Name first, then email, then phone.
// Keys are lowercase so getOnboardingFieldOrder(fieldType) works for any casing.
export const ONBOARDING_FIELD_ORDER = {
  fullname: 0,
  name: 0,
  username: 0,
  email: 1,
  phone: 2,
  mobileno: 2,
};

export const getOnboardingFieldOrder = (fieldType) => {
  if (!fieldType) return 99;
  const key = String(fieldType).toLowerCase();
  return ONBOARDING_FIELD_ORDER[key] ?? 99;
};
